export default __webpack_public_path__ + "static/media/480_dummy2016-beauty01-de.719ac83c.png";